/* globals vis*/
/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of trackervalues (patients) to display or load trackervalues */



(function () {
    'use strict';
    angular.module('vctracker')
        .component('trackervaluegraph', {
            restrict: 'E',
            bindings: {
                clientid: '<',
                trackerid: '<',
                snapshothandle: '&'
            },
            template: `
           <div class="alert alert-info" ng-show="vm.novalue"><h4><i class="fa fa-info-circle"></i> Keine Daten vorhanden!</h4></div>
           <div class="graph" id="{{vm.graphid}}"></div>
           <div class="btn btn-primary" ng-click="vm.snap()"><i class="fa fa-camera"></i> </div>
      `,
            controllerAs: 'vm',
            controller: ['$log', '$http', 'Rlog', 'Trackervalue', 'TrackervalueHelper', 'vertxEventBusService', '$document',
                function ($log, $http, Rlog, Trackervalue, TrackervalueHelper, vertxEventBusService, $document) {
                    let vm = this;
                    vm.editTrackervalue = TrackervalueHelper.editTrackervalue;
                    vm.removeTrackervalue = removeTrackervalue;
                    vm.snap = snap;

                    vm.$onChanges = function (changes) {
                        // clientid might be propagating late
                        if (angular.isDefined(changes.clientid) &&
                            angular.isDefined(changes.clientid.currentValue &&
                                changes.clientid.currentValue.length > 0)) {
                            vm.clientid = changes.clientid.currentValue;
                        }
                        // trackerid might be propagating late
                        if (angular.isDefined(changes.trackerid) &&
                            angular.isDefined(changes.trackerid.currentValue &&
                                changes.trackerid.currentValue.length > 0)) {
                            vm.trackerid = changes.trackerid.currentValue;
                            // create unique graph containerid in case componed is rendered multiple times
                            vm.graphid = changes.trackerid.currentValue + Math.floor(Math.random() * 10000).toString();
                        }
                        // only get values once both ids are ready and values have not been fetched yet
                        if (angular.isDefined(vm.clientid) && angular.isString(vm.clientid) && vm.clientid.length > 0 &&
                            angular.isDefined(vm.trackerid) && angular.isString(vm.trackerid) && vm.trackerid.length > 0 &&
                            angular.isUndefined(vm.trackervalues)) {
                            $log.debug('onChanges getValues for tracker: ', vm.trackerid);
                            getValuesAndDraw();
                        }
                    };


                    function getValuesAndDraw() {
                        Trackervalue.$search({
                            query: {trackerid: vm.trackerid, active: true, clientid: vm.clientid},
                            options: {sort: {dateiso: 1}}
                        })
                            .$then(function (values) {
                                // only draw, if there is a container to draw into
                                $log.debug('values in search.$then: ', values);
                                vm.trackervalues = values;
                                drawWithPlotly(vm.trackervalues);
                            });
                    }


                    function drawWithPlotly(values) {
                        if (angular.isDefined(values) && angular.isArray(values) && values.length > 0) {
                            let container = $document[0].getElementById(vm.graphid);

                            // format of values: [{value1}, {value2}, ...]
                            // format for value: {name, dateat, dateiso, def: [{dp_subgraph11}, {dp_subgraph2}, ...]}
                            // format for dp_subgraph: {absmax, absmin, normmax, normmin, step, unit, value, label}

                            if (angular.isDefined(container) && container !== null) {

                                //  target: var data = [ subgraph1, subgraph2, ... ];
                                //  target subgraph: {x: [], y: [], mode: 'lines'}  mode options: lines, markers, lines+markers
                                //  create linegraph for all subgraphs
                                //  create ok symbol scatter graph for all ok values for all subgraphs
                                //  create not-ok symbol scatter graph for all not-ok values for all subgraphs

                                let numOfSubgraphs = values[0].def.length; // TODO: make sure to get the absolute value of max sub graphs

                                let subgraphs = [];
                                let posgraph = {
                                    x: [],
                                    y: [],
                                    mode: 'markers',
                                    name: 'normal',
                                    marker: {
                                        color: 'green',
                                        size: 10,
                                        symbol: 'circle'
                                    }
                                };
                                let neggraph = {
                                    x: [],
                                    y: [],
                                    mode: 'markers',
                                    name: 'nicht normal',
                                    marker: {
                                        color: 'red',
                                        size: 10,
                                        symbol: 'x'
                                    }
                                };
                                let neutralgraph = {
                                    x: [],
                                    y: [],
                                    mode: 'markers',
                                    name: 'kein Normbereich',
                                    marker: {
                                        color: 'grey',
                                        size: 10,
                                        symbol: 'star'
                                    }
                                };

                                values.forEach((val) => {
                                    for (let i = 0; i < numOfSubgraphs; i++) {
                                        let dp = val.def[i];
                                        if (angular.isUndefined(subgraphs[i])) {
                                            subgraphs[i] = {
                                                x: [],
                                                y: [],
                                                mode: 'lines',
                                                name: dp.label + ' [' + dp.unit + ']',
                                                line: {
                                                    shape: 'spline',
                                                    smoothing: 1.3
                                                }
                                            };
                                        }

                                        subgraphs[i].x.push(val.dateiso);
                                        subgraphs[i].y.push(dp.value);

                                        if (angular.isDefined(dp.normmin) && angular.isDefined(dp.normmin) &&
                                            dp.value >= dp.normmin && dp.value <= dp.normmax) {
                                            posgraph.x.push(val.dateiso);
                                            posgraph.y.push(dp.value);
                                        }
                                        else if (angular.isDefined(dp.normmin) && angular.isDefined(dp.normmin) &&
                                            (dp.value < dp.normmin || dp.value > dp.normmax)) {
                                            neggraph.x.push(val.dateiso);
                                            neggraph.y.push(dp.value);
                                        } else {
                                            neutralgraph.x.push(val.dateiso);
                                            neutralgraph.y.push(dp.value);
                                        }
                                    }
                                });

                                let totalPoints = 0;
                                if (posgraph.x.length > 0) {
                                    subgraphs.push(posgraph);
                                    totalPoints += posgraph.x.length;
                                }
                                if (neggraph.x.length > 0) {
                                    subgraphs.push(neggraph);
                                    totalPoints += neggraph.x.length;

                                }
                                if (neutralgraph.x.length > 0) {
                                    subgraphs.push(neutralgraph);
                                    totalPoints += neutralgraph.x.length;

                                }

                                let layout = {
                                    title: values[0].name,
                                    hovermode: 'closest'
                                };

                                if (totalPoints === 1) {
                                    layout.xaxis = {range: [moment().subtract(2, 'days').toISOString(), moment().add(2, 'days').toISOString()]}
                                }

                                let options = {
                                    hovermode: 'closest',
                                    scrollZoom: true,
                                    locale: 'de-at',
                                    showLink: false,
                                    displaylogo: false,
                                    modeBarButtonsToRemove: ['sendDataToCloud', 'lasso2d', 'select2d']
                                };


                                Plotly.react(container, subgraphs, layout, options).then(
                                    function (plotlyref) {
                                        $log.debug('plotlyref in promise: ', plotlyref);
                                        vm.plotlyref = plotlyref;
                                        vm.snapshothandle({plotlyref: plotlyref, trackerid: vm.trackerid});
                                    });


                            }
                            else {
                                $log.debug('container for graph not found, graphid: ', vm.graphid);
                            }
                        }
                        else {
                            vm.novalue = true;
                        }
                    }

                    function removeTrackervalue(trackervalue) {
                        trackervalue.active = false;
                        trackervalue.$save();
                    }

                    function snap() {
                        let style = angular.element(vm.plotlyref)[0].firstChild.firstChild.style;
                        let width = parseInt(style.width.substr(0, style.width.indexOf('px')), 10);
                        let height = parseInt(style.height.substr(0, style.height.indexOf('px')), 10);
                        Plotly.toImage(vm.plotlyref,{height: height, width: width})
                            .then(
                                function(url)
                                {
                                    // $log.debug('img url: ', url);
                                    vm.snapshothandle({snapshot: url});
                                }
                            );
                    }

                    const tvUpdateHandler = function (message) {
                        if (angular.isDefined(vm.trackervalues)){
                            vm.trackervalues.$refresh().$then(function (values) {
                                $log.debug('******** refreshed values for message: ', values, message);
                                drawWithPlotly(values);
                            }, function (error) {
                                $log.error('debug: trackervaluegraph refresh trackervalues failed: ', error);
                            });
                        }
                    };

                    const tiSaveHandler = function (message) {
                        $log.debug('******** saved tracker image for tracker: ', message);
                    };

                    vertxEventBusService.on('trackervalues.update', {}, tvUpdateHandler);
                    vertxEventBusService.on('trackerimage.saved', {}, tiSaveHandler);

                    vm.$onDestroy = function () {
                        vertxEventBusService.unregisterHandler('trackervalues.update', {}, tvUpdateHandler);
                        vertxEventBusService.unregisterHandler('trackerimage.saved', {}, tiSaveHandler());
                    };


                }] // controller
        }); // component

    // klammerfriedhof
}());
